import { replaceAllSpaceToHalfSpace } from './space';

export const isStringMatch = (value: string | undefined, trueValue: string): boolean => {
  if (value === trueValue) {
    return true;
  }
  return false;
};

export const splitStringBySpace = (value: string | undefined): string[] => {
  return replaceAllSpaceToHalfSpace(value ?? '')
    .split(' ')
    .filter((d) => d !== '');
};
